var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"next-project",class:{
		'next-project_mobile': _vm.mobileMode,
		'next-project_desktop': !_vm.mobileMode,
	}},[_c('header',{staticClass:"next-project__description-wrapper"},[_c('button',{staticClass:"next-project__button",attrs:{"type":"button","role":"link"},domProps:{"innerHTML":_vm._s(_vm.title)},on:{"click":function($event){return _vm.$emit('click')}}})])])}
var staticRenderFns = []

export { render, staticRenderFns }